export const BranchesStates = {
    SUCCESS: 'Branches_SUCCESS',
    FAILED: 'Branches_FAILED',
    RESET: 'Branches_RESET',
};
